import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface HealthWarningDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dangerMode: boolean) => void;
  healthConcerns: string[];
}

const HealthWarningDialog: React.FC<HealthWarningDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  healthConcerns,
}) => {
  const concernsList = healthConcerns.length > 0 
    ? healthConcerns.join(', ') 
    : 'health';

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[525px]">
        <DialogHeader>
          <DialogTitle className="mb-4">Your health concerns</DialogTitle>
          <DialogDescription>
            You've mentioned that you have concerns related to {concernsList}.
            <br /> <br />
            Are you open to us recommending alternative treatments and/or experimental supplements that may help address these concerns?
            <br /> <br />
            It's important to note that most, if not all, of these treatments have limited research and are generally not medically approved for common usage. If your health concerns are a significant worry, we recommend speaking to your doctor or a qualified health professional.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 mx-auto mt-4">
          <Button 
            variant="outline" 
            onClick={() => {
              onClose();
              onConfirm(false);
            }}
          >
            Don't show me these
          </Button>
          <Button onClick={() => {
            onClose();
            onConfirm(true);
          }}>
            Yes, I'm open to alternatives
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default HealthWarningDialog; 